import { Controller } from "@hotwired/stimulus"

// Ui::Form::TextAreaComponent `recommended_length:` option: counts the characters
// and flags the field (no hard limit) and shows the warning badge once it goes over the recommended length.
export default class extends Controller {
  static targets = ["input", "counter", "badge"]
  static values = { recommended: Number }

  connect () {
    this.update()
  }

  update () {
    const length = this.inputTarget.value.length
    const over = length > this.recommendedValue

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = length
      // Colour only: the hint keeps `.text-muted` (admin font size and spacing).
      this.counterTarget.closest(".text-muted")?.classList.toggle("text-muted--warning", over)
    }
    if (this.hasBadgeTarget) this.badgeTarget.hidden = !over
    this.inputTarget.classList.toggle("field_with_warning", over)
  }
}
